<template>
  <div>
    <v-dialog v-model="toggle" persistent width="500">
      <v-card outlined class="r0">
        <!-- <div><v-icon>mdi-close</v-icon></div> -->
        <v-container class="mb-5">
          <template>
            <h3 class="mt-5">
              <v-icon class="mr-2">mdi-share-variant-outline</v-icon> Share
              Account
            </h3>
            <p class="light-weight mt-3">Who has access</p>

            <v-icon style="float: left; font-size: 45px" class="mr-5 pa-1 pl-5"
              >mdi-account-circle</v-icon
            >
            <v-btn icon style="float: right" class="mt-2 mr-2"
              ><v-icon>mdi-delete</v-icon></v-btn
            >
            <div style="background: #f4f4f4; border-radius: 25px 25px 0px 25px">
              <p class="mb-1">Admin</p>
              <p class="light-weight">Zwizai@gmail.com</p>
            </div>

            <v-icon style="float: left; font-size: 45px" class="mr-5 pa-1 pl-5"
              >mdi-account-circle</v-icon
            >
            <v-btn icon style="float: right" class="mt-2 mr-2"
              ><v-icon>mdi-delete</v-icon></v-btn
            >
            <div style="background: #f4f4f4; border-radius: 25px 25px 0px 25px">
              <p class="mb-1">Editor</p>
              <p class="light-weight">IaziwZ@gmail.com</p>
            </div>
            <hr />
            <h3 class="mt-5">
              <v-icon class="mr-2">mdi-link-variant</v-icon> Link
            </h3>
            <v-btn style="float: right" class="mt-1">คัดลอกลิงก์</v-btn>
            <div
              class="mr-5 pl-5 mt-3"
              style="background: #f4f4f4; border-radius: 25px 25px 0px 25px"
            >
              <p class="light-weight">https://xxxxxxxxxxx.xxxxxxxxxxxxxxxxx…</p>
            </div>

            <v-icon style="float: left; font-size: 45px" class="mr-5 pa-1 pl-5"
              >mdi-account-circle</v-icon
            >
            <v-btn style="float: right" class="mt-2">เปลี่ยน</v-btn>
            <div style="background: #f4f4f4; border-radius: 25px 25px 0px 25px">
              <p class="mb-1">ทุกคนที่มีลิงก์</p>
              <p class="light-weight">
                ผู้ใช้อินเทอร์เน็ตทุกคนที่มีลิงก์จะดูได้
              </p>
            </div>

            <v-btn
              outlined
              class="btn-custom btn-next-richmenu w45 right"
              @click="$emit('input', false)"
              ><span>เสร็จสิ้น</span>
            </v-btn>
            <!-- <div class="mt-10">
              <v-btn width="344" height="46" outlined class="btn-custom bg-two-tone pa-5">
                <v-img width="30" :src="Rectangle" class="ma-3"></v-img>
                <span style="font-size: 20px; margin-right: 63px;">Upload an image</span>
              </v-btn>
              <v-btn
                width="344"
                height="46"
                outlined
                class="btn-custom bg-two-tone mt-5 pa-5"
                @click="$emit('input', false)"
              >
                <v-img width="30" :src="Rectangles" class="ma-3"></v-img>
                <span style="font-size: 20px;">Back</span>
              </v-btn>
            </div> -->
          </template>
        </v-container>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  props: ['value'],
  data() {
    return {
      toggle: this.value
    }
  }
}
</script>

<style lang="scss" scoped></style>
